import { captureException } from "../utils/sentry/lazy-sentry.js";
import { Component } from "react";
import { Button, Icon } from "@therms/atalaya";
import { jsx, jsxs } from "react/jsx-runtime";
import { MdError } from "react-icons/md";
//#region src/components/ErrorBoundary.tsx
var ErrorBoundary = class extends Component {
	constructor(props) {
		super(props);
		this.state = {
			error: null,
			errorInfo: null,
			hasError: false
		};
	}
	static getDerivedStateFromError(error) {
		return { hasError: true };
	}
	componentDidCatch(error, errorInfo) {
		console.error("React#ErrorBoundary", error, errorInfo);
		captureException(error, { extra: { componentStack: errorInfo.componentStack } });
		this.props.onError?.(error, errorInfo);
	}
	reset = () => {
		console.info("React#ErrorBoundary resetting");
		if (this.props.onResetError) this.props.onResetError();
		else this.setState({ hasError: false });
	};
	render() {
		if (this.state.hasError) return /* @__PURE__ */ jsxs("div", {
			className: "space-small text-danger",
			children: [/* @__PURE__ */ jsxs("div", {
				className: "flex",
				children: [/* @__PURE__ */ jsx(Icon, {
					Icon: MdError,
					color: "critical"
				}), /* @__PURE__ */ jsx("div", { children: "An Error Occurred" })]
			}), this.props.onResetError && /* @__PURE__ */ jsx("div", {
				className: "mt-sm",
				children: /* @__PURE__ */ jsx(Button, {
					onClick: this.reset,
					outline: true,
					variant: "critical",
					children: "Reload"
				})
			})]
		});
		return this.props.children;
	}
};
//#endregion
export { ErrorBoundary };

//# sourceMappingURL=ErrorBoundary.js.map